export const AGENT_PATH_RE = /^\/agent\/([^/]+)/;

export namespace Urls {
  export const home = () => '/';
  export const demos = () => '/demos';
  export const agents = () => '/agents';
  export const agent = (id: string) => `/agent/${id}`;
  export const settings = () => '/settings';
  export const billing = () => '/settings/billing';
}

export namespace Titles {
  export const chat = () => 'Chat';
  export const demos = () => 'Demos';
  export const agents = () => 'Agents';
  export const settings = () => 'Settings';
  export const billing = () => 'Billing';
  export const agent = (name: string) => name;
}
